'use client';

import {
  createContext,
  type ReactNode,
  useContext,
} from 'react';
import type { NotifyMeFlyInCompositionData } from '@/ui/components/NotifyMeFlyIn/notify-me-fly-in-composition-types';

export type NotifyMeFlyInCompositionContextValue =
  NotifyMeFlyInCompositionData | null;

const NotifyMeFlyInCompositionContext =
  createContext<NotifyMeFlyInCompositionContextValue>(null);

export function NotifyMeFlyInCompositionProvider({
  children,
  composition,
}: {
  children: ReactNode;
  composition: NotifyMeFlyInCompositionData | null;
}) {
  return (
    <NotifyMeFlyInCompositionContext.Provider value={composition}>
      {children}
    </NotifyMeFlyInCompositionContext.Provider>
  );
}

export function useNotifyMeFlyInComposition(): NotifyMeFlyInCompositionContextValue {
  return useContext(NotifyMeFlyInCompositionContext);
}
